import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

import icPodium from '@/assets/ic_podium.svg';
import { Card, Divider } from '@/components';
import { TshirtTeam } from '@/components/TshirtTeam';
import useAuth from '@/hooks/useAuth';
import useTshirtAndShield from '@/hooks/useTshirtAndShield';
import { DataTableType, ResponseTdeRankingData } from '@/types/tde';
import { cn, FADE_IN_OUT } from '@/utils';

const StatBlock = ({
  label,
  value,
  className,
}: {
  label: string;
  value: string | number;
  className?: string;
}) => (
  <div className={`flex gap-3 ${className}`}>
    <p className="text-[12px] text-gdt-gray-4">{label}</p>
    <p className="text-[24px] font-bold">{value}</p>
  </div>
);

const SectionHeader = ({ icon, title }: { icon?: string; title: string }) => (
  <div className="flex items-center space-x-2 mt-6">
    {icon && (
      <figure>
        <img alt={`Icono de ${title}`} src={icon} />
      </figure>
    )}
    <p className="font-bold text-[16px]">{title}</p>
  </div>
);

const UserScoreCard = ({
  schooldata,
  tabRanking,
  isParticipatingInTournament,
  dataTable,
}: {
  schooldata: ResponseTdeRankingData;
  tabRanking: number;
  isParticipatingInTournament: boolean;
  dataTable: DataTableType;
}) => {
  const { userInitialData } = useAuth();
  const [mySchooldPosicion, setMySchoolPosicion] = useState({
    lastDate: 0,
    general: 0,
  });

  const { data: dataTshirtShield } = useTshirtAndShield();

  useEffect(() => {
    if (tabRanking === 2) {
      const lastDatePos = dataTable.mySchoolsData.findIndex(
        (user) => user.idUsuario === userInitialData?.idUsuarioDT
      );
      const generalPos = dataTable.mySchoolDataGeneral.findIndex(
        (user) => user.idUsuario === userInitialData?.idUsuarioDT
      );
      setMySchoolPosicion({
        lastDate: lastDatePos !== -1 ? lastDatePos + 1 : 0,
        general: generalPos !== -1 ? generalPos + 1 : 0,
      });
      return;
    }
    const getData = async () => {
      setMySchoolPosicion({
        lastDate: schooldata.escuelaUsuario?.posicionFechaAlumno ?? 0,
        general: schooldata.escuelaUsuario?.posicionGralAlumno ?? 0,
      });
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTable]);

  const getPositionData = (type: 'lastDate' | 'general') => {
    return mySchooldPosicion[type] === 0 ? '-' : mySchooldPosicion[type];
  };

  return (
    <>
      {isParticipatingInTournament && schooldata && schooldata.tieneEdad && (
        <Card className={cn('p-0 bg-white w-[426px] ml-8 px-5 pt-6 pb-3', {})}>
          <div className="flex">
            <figure className="w-[4.5rem]">
              <TshirtTeam
                shield={dataTshirtShield?.shield}
                tshirt={dataTshirtShield?.tshirt}
                withShield={true}
              />
            </figure>
            <div className="ml-7">
              <p className="text-lg font-bold text-gdt-gray">
                {schooldata.nombreEquipo}
              </p>
              <span className="text-gdt-gray-3 block">
                DT {schooldata.escuelaUsuario?.nombreAlumno}
              </span>
              <p className="font-bold text-[14px] text-gdt-blue lowercase">
                {schooldata.escuelaUsuario?.nombreEscuela}
              </p>
            </div>
          </div>
          {tabRanking !== 0 && (
            <motion.div
              animate={'show'}
              initial={'hide'}
              variants={FADE_IN_OUT}
            >
              <Divider
                className="bg-gdt-gray-6 w-[calc(100%+4rem)] relative -left-[2rem] mt-6"
                type="horizontal"
              />
              <SectionHeader icon={icPodium} title="Puntos" />
              <div className="flex justify-between p-4 mt-4">
                <StatBlock
                  label={
                    userInitialData?.primera_fecha
                      ? 'PRIMERA FECHA'
                      : 'ÚLTIMA FECHA'
                  }
                  value={
                    userInitialData?.puntos_fecha
                      ? userInitialData?.puntos_fecha
                      : '-'
                  }
                />
                <StatBlock
                  label="TORNEO"
                  value={
                    userInitialData?.puntos_general
                      ? userInitialData?.puntos_general
                      : '-'
                  }
                />
              </div>
              <Divider
                className="bg-gdt-gray-6 w-[calc(100%+4rem)] relative -left-[2rem] mt-6"
                type="horizontal"
              />
              <SectionHeader title="Posición" />
              <div className="flex justify-between p-4 mt-4">
                <StatBlock
                  label={
                    userInitialData?.primera_fecha
                      ? 'PRIMERA FECHA'
                      : 'ÚLTIMA FECHA'
                  }
                  value={getPositionData('lastDate')}
                />
                <StatBlock label="TORNEO" value={getPositionData('general')} />
              </div>
            </motion.div>
          )}
        </Card>
      )}
    </>
  );
};

export default UserScoreCard;
